import { colors } from 'styles/colors';
import { ThermalComfortVariant } from './components/UnitsInfo/types';
import { t } from 'i18next';

export function colorByThermalComfortVariant(variant: ThermalComfortVariant): string {
  switch (variant) {
    case 'aboveLimit': return colors.state.danger.base;
    case 'belowLimit': return colors.state.cold.base;
    case 'comfortable': return colors.state.success.base;
    default: return colors.icon['soft-400'];
  }
}

export function hoverColorByThermalComfortVariant(variant: ThermalComfortVariant): string {
  switch (variant) {
    case 'aboveLimit': return colors.state.danger.dark;
    case 'belowLimit': return colors.state.cold.dark;
    case 'comfortable': return colors.state.success.dark;
    default: return colors.icon['strong-800'];
  }
}

export function parseThermalComfortVariantLabel(variant: ThermalComfortVariant): string {
  switch (variant) {
    case 'aboveLimit': return t('acimaLimite');
    case 'belowLimit': return t('abaixoLimite');
    case 'comfortable': return t('confortavel');
    default: return t('semConexao');
  }
}

export function canSeeDetailsButtonByValue(value: number | undefined): boolean {
  return (value ?? 0) > 0;
}
